import React, { useMemo, useState } from "react";
import { Typography, Box, Divider, List, ListItemButton } from "@mui/material";
//import { productDataList } from "../data/productListData";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { authoringSectionsByKey } from "../data/authoringSections";

const AUTHORING_NAV_KEYS = [
  "items",
  "lessons",
  "assets",
  "assignments",
  "taxonomy",
];

const ToggleDrawer = ({
  handleDrawerToggle,
  mobileOpen,
  onAboutClick,
  onInstClick,
  ontestimonialClick,
  onCompareProClick,
  onQARefClick,
}) => {
  const [expanded, setExpanded] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthoringPage = location.pathname.startsWith("/authoring");
  const authoringNavItems = useMemo(
    () =>
      AUTHORING_NAV_KEYS.map((key) => {
        const section = authoringSectionsByKey[key];
        if (!section || !section.types || section.types.length === 0) {
          return null;
        }
        const [firstType] = section.types;
        return {
          key,
          label: section.label,
          path: `/authoring/${section.key}/${firstType.key}`,
        };
      }).filter(Boolean),
    []
  );
  // Handle mouse enter event on the Products button
  // const handleToggle = (index) => {
  //   setExpanded(expanded === index ? null : index); // Toggle between expanded and collapsed
  // };

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2, // Padding for spacing
          borderBottom: "1px solid #ddd", // Optional, adds a subtle border
        }}
      >
        <Link to="/" style={{ textDecoration: "none" }}>
          <img
            src={logo}
            alt="Logo"
            style={{
              height: 40, // or whatever height suits your design
              cursor: "pointer",
            }}
          />
        </Link>
        <IconButton
          sx={{ color: "primary.main", background: "#f4f4f4" }}
          onClick={handleDrawerToggle}
        >
          <ClearIcon />
        </IconButton>
      </Box>
      <Divider />
      <List>
        {isAuthoringPage ? (
          authoringNavItems.map((item, index) => (
            <React.Fragment key={item.key}>
              <ListItemButton
                onClick={() => {
                  navigate(item.path);
                  handleDrawerToggle();
                }}
                selected={location.pathname.startsWith(
                  `/authoring/${item.key}`
                )}
                sx={{ borderRadius: 1, mx: 1, my: 0.25 }}
              >
                <Typography variant="body1">{item.label}</Typography>
              </ListItemButton>
              {index < authoringNavItems.length - 1 && <Divider />}
            </React.Fragment>
          ))
        ) : (
          <>
            <ListItemButton
              onClick={() => {
                onAboutClick(); // scrolls to the ref
                handleDrawerToggle(); // closes the drawer
              }}
            >
              <Typography variant="body1">About the Course</Typography>
            </ListItemButton>
            <Divider />
            <ListItemButton
              component={Link}
              //to="/about"
              onClick={handleDrawerToggle}
            >
              <Typography variant="body1">Enroll</Typography>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onClick={() => {
                onInstClick();
                handleDrawerToggle();
              }}
            >
              <Typography variant="body1">Instructor</Typography>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onClick={() => {
                ontestimonialClick();
                handleDrawerToggle();
              }}
            >
              <Typography variant="body1">Testimonials</Typography>
            </ListItemButton>

            <Divider />
            <ListItemButton
              onClick={() => {
                onCompareProClick();
                handleDrawerToggle();
              }}
            >
              <Typography variant="body1">Compare Progams</Typography>
            </ListItemButton>
            <Divider />
            <ListItemButton
              onClick={() => {
                onQARefClick();
                handleDrawerToggle();
              }}
            >
              <Typography variant="body1">Q&A</Typography>
            </ListItemButton>
            <Divider />
            <ListItemButton
              component={Link}
              to="/contact"
              onClick={() => {
                handleDrawerToggle();
              }}
            >
              <Typography variant="body1">Contact</Typography>
            </ListItemButton>
          </>
        )}
      </List>
    </Box>
  );
};

export default ToggleDrawer;
